enum BeaconStatus {
  ACTIVE_ONGOING = 'active_ongoing',
}
export { BeaconStatus };
